import React from "react";

interface ButtonProps {
  label: string;
  type?: "primary" | "secondary" | "danger" | 'purple' | 'grey' | 'large';
  disabled?: boolean;
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  label,
  type = "secondary",
  disabled = false,
  onClick,
}) => {
  const baseClasses =
    "px-4  py-2  focus:outline-none transition-all duration-200 ease-in-out h-max font-bold	";
  const disabledClasses = "opacity-50 cursor-not-allowed";

  const typeClasses = {
    primary: "bg-cyan text-white active:bg-blue-700",
    secondary: "bg-lightgrey hover:bg-gray-600 active:bg-gray-700",
    danger: "bg-red-500 hover:bg-red-600 active:bg-red-700",
    purple: " text-white bg-purple rounded font-normal transition duration-200 hover:bg-[#F3E6F4] hover:text-purple",
    grey: " text-black bg-gray-200 font-normal rounded transition duration-200 hover:bg-gray-300",
    large: "text-white bg-purple rounded font-normal transition duration-200 hover:bg-[#F3E6F4] hover:text-purple px-8",
  };

  return (
    <button
      className={`${baseClasses} ${typeClasses[type]} ${
        disabled ? disabledClasses : ""
      }`}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default Button;
